<template>
  <div class="home-page">
    <!-- 顶部用户信息区 -->
    <div class="home-header">
      <!-- 移除背景装饰，保持清爽 -->
      <div class="header-content">
        <div class="header-top">
          <div class="logo-area">
            <svg class="jj-logo" viewBox="0 0 216 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M45.3061 20.8646C43.775 20.8646 42.9213 19.4147 42.9213 16.7914C42.9213 14.1274 43.775 12.7182 45.3061 12.7182C46.8373 12.7182 47.691 14.1491 47.691 16.7914C47.6883 19.4553 46.8346 20.8646 45.3061 20.8646ZM45.3061 11.6261C42.1869 11.6261 40.4579 13.9513 40.4579 16.7914C40.4579 19.6315 42.1869 21.9567 45.3061 21.9567C48.4254 21.9567 50.1544 19.6315 50.1544 16.7914C50.1544 13.9513 48.4254 11.6261 45.3061 11.6261ZM66.9809 11.6261C65.5094 11.6261 64.6964 12.2629 64.2384 13.0759H64.1191V11.8239H61.775V21.7589H64.1191V15.3415C64.1191 13.8727 64.8752 13.0163 66.0866 13.0163C67.2601 13.0163 67.775 13.7914 67.775 14.9648V21.7589H70.1191V14.9431C70.1219 12.8971 69.0487 11.6261 66.9809 11.6261ZM75.4444 11.6261C73.279 11.6261 71.6503 12.5394 71.6503 14.4879C71.6503 16.1383 72.7831 17.0326 74.0541 17.3497L76.0406 17.8456C77.0948 18.103 77.5717 18.4824 77.5717 19.3171C77.5717 20.3307 76.8563 20.9079 75.6042 20.9079C74.2519 20.9079 73.5582 20.2521 73.3387 18.6044L71.233 19.2006C71.3522 20.9106 72.943 21.9621 75.3468 21.9621C78.0297 21.9621 79.4796 20.7101 79.4796 18.7236C79.4796 16.8564 78.1869 16.0814 76.8373 15.7426L74.9294 15.2656C73.9755 15.0272 73.5582 14.5908 73.5582 13.954C73.5582 13.1599 74.233 12.683 75.2465 12.683C76.4389 12.683 77.1733 13.3388 77.2736 14.5908L79.2601 13.9946C79.0216 12.599 77.6503 11.6261 75.4444 11.6261ZM85.3007 20.8646C83.7696 20.8646 82.9159 19.4147 82.9159 16.7914C82.9159 14.1274 83.7696 12.7182 85.3007 12.7182C86.8319 12.7182 87.6855 14.1491 87.6855 16.7914C87.6855 19.4553 86.8292 20.8646 85.3007 20.8646ZM85.3007 11.6261C82.1815 11.6261 80.4525 13.9513 80.4525 16.7914C80.4525 19.6315 82.1815 21.9567 85.3007 21.9567C88.42 21.9567 90.149 19.6315 90.149 16.7914C90.149 13.9513 88.42 11.6261 85.3007 11.6261ZM96.7452 11.6261C95.2736 11.6261 94.4606 12.2629 94.0026 13.0759H93.8834V11.8239H91.5392V21.7589H93.8834V15.3415C93.8834 13.8727 94.6395 13.0163 95.8509 13.0163C97.0243 13.0163 97.5392 13.7914 97.5392 14.9648V21.7589H99.8834V14.9431C99.8834 12.8971 98.8102 11.6261 96.7452 11.6261ZM131.574 20.8646C130.043 20.8646 129.19 19.4147 129.19 16.7914C129.19 14.1274 130.043 12.7182 131.574 12.7182C133.106 12.7182 133.959 14.1491 133.959 16.7914C133.959 19.4553 133.103 20.8646 131.574 20.8646ZM131.574 11.6261C128.455 11.6261 126.726 13.9513 126.726 16.7914C126.726 19.6315 128.455 21.9567 131.574 21.9567C134.694 21.9567 136.423 19.6315 136.423 16.7914C136.423 13.9513 134.694 11.6261 131.574 11.6261ZM153.249 11.6261C151.778 11.6261 150.965 12.2629 150.507 13.0759H150.387V11.8239H148.043V21.7589H150.387V15.3415C150.387 13.8727 151.144 13.0163 152.355 13.0163C153.528 13.0163 154.043 13.7914 154.043 14.9648V21.7589H156.387V14.9431C156.39 12.8971 155.317 11.6261 153.249 11.6261ZM161.715 11.6261C159.55 11.6261 157.921 12.5394 157.921 14.4879C157.921 16.1383 159.054 17.0326 160.325 17.3497L162.312 17.8456C163.366 18.103 163.843 18.4824 163.843 19.3171C163.843 20.3307 163.127 20.9079 161.875 20.9079C160.523 20.9079 159.829 20.2521 159.61 18.6044L157.504 19.2006C157.623 20.9106 159.214 21.9621 161.618 21.9621C164.301 21.9621 165.751 20.7101 165.751 18.7236C165.751 16.8564 164.458 16.0814 163.108 15.7426L161.2 15.2656C160.247 15.0272 159.829 14.5908 159.829 13.954C159.829 13.1599 160.504 12.683 161.518 12.683C162.71 12.683 163.444 13.3388 163.545 14.5908L165.531 13.9946C165.29 12.599 163.919 11.6261 161.715 11.6261ZM171.569 20.8646C170.038 20.8646 169.184 19.4147 169.184 16.7914C169.184 14.1274 170.038 12.7182 171.569 12.7182C173.1 12.7182 173.954 14.1491 173.954 16.7914C173.954 19.4553 173.097 20.8646 171.569 20.8646ZM171.569 11.6261C168.45 11.6261 166.721 13.9513 166.721 16.7914C166.721 19.6315 168.45 21.9567 171.569 21.9567C174.688 21.9567 176.417 19.6315 176.417 16.7914C176.417 13.9513 174.688 11.6261 171.569 11.6261ZM183.013 11.6261C181.542 11.6261 180.729 12.2629 180.271 13.0759H180.152V11.8239H177.807V21.7589H180.152V15.3415C180.152 13.8727 180.908 13.0163 182.119 13.0163C183.293 13.0163 183.807 13.7914 183.807 14.9648V21.7589H186.152V14.9431C186.152 12.8971 185.078 11.6261 183.013 11.6261ZM39.0677 7.85101H36.6042V18.122C36.6042 19.7914 35.9674 20.7833 34.4579 20.7833C32.9674 20.7833 32.3116 19.7291 32.3116 17.9215V16.0136L29.8481 16.6288V17.4824C29.8481 20.0841 31.1408 22.0732 34.4579 22.0732C37.775 22.0732 39.0677 20.0868 39.0677 17.4824V7.85101ZM53.8888 7.85101H51.5446V21.7589H53.8888V15.3415C53.8888 13.8727 54.6449 13.0163 55.8563 13.0163C57.0297 13.0163 57.5446 13.7914 57.5446 14.9648V21.7589H59.8888V14.9431C59.8888 12.8971 58.8156 11.6261 56.7506 11.6261C55.279 11.6261 54.466 12.2629 54.008 13.0759H53.8888V7.85101ZM125.336 7.85101H122.873V18.122C122.873 19.7914 122.236 20.7833 120.726 20.7833C119.236 20.7833 118.58 19.7291 118.58 17.9215V16.0136L116.116 16.6288V17.4824C116.116 20.0841 117.409 22.0732 120.726 22.0732C124.043 22.0732 125.336 20.0868 125.336 17.4824V7.85101ZM140.157 7.85101H137.813V21.7589H140.157V15.3415C140.157 13.8727 140.913 13.0163 142.125 13.0163C143.298 13.0163 143.813 13.7914 143.813 14.9648V21.7589H146.157V14.9431C146.157 12.8971 145.084 11.6261 143.019 11.6261C141.547 11.6261 140.734 12.2629 140.276 13.0759H140.157V7.85101ZM107.612 20.6261C105.705 20.6261 104.534 19.0759 104.534 17.4282C104.534 16.3957 104.992 15.4418 105.745 14.9052L110.236 19.8131C109.401 20.309 108.466 20.6261 107.612 20.6261ZM111.984 18.1816L108.089 13.8889C108.786 13.6098 109.461 13.5123 110.016 13.5123C111.626 13.5123 112.618 14.4472 112.618 16.057C112.621 16.7724 112.42 17.5068 111.984 18.1816ZM107.553 13.3144L106.699 12.3605C105.943 11.5258 105.726 11.0082 105.726 10.393C105.726 9.24125 106.461 8.58543 107.612 8.58543C108.786 8.58543 109.48 9.26022 109.48 10.4933C109.48 11.6261 108.924 12.6992 107.553 13.3144ZM107.672 7.53394C104.929 7.53394 103.58 9.0651 103.58 10.9702C103.58 12.0028 104.016 13.038 105.171 14.2873L105.19 14.328C103.244 15.2629 102.35 16.7724 102.35 18.3226C102.35 20.3686 103.919 22.0787 106.344 22.0787C107.734 22.0787 109.363 21.5014 110.835 20.4689L112.027 21.7616H115.146V21.6613L112.604 18.8591C113.677 17.5881 114.293 16.1979 114.293 14.9838C114.293 13.4743 113.279 12.4608 111.691 12.4608C110.856 12.4608 109.921 12.6992 109.306 12.9377L109.266 12.8591C110.775 12.0434 111.412 11.29 111.412 10.2358C111.406 8.72635 110.057 7.53394 107.672 7.53394Z" fill="#d51900"/>
            </svg>
          </div>
          <div class="header-actions">
            <div class="scan-btn" @click="scan">
              <svg class="scan-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 7V5C3 3.89543 3.89543 3 5 3H7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <path d="M17 3H19C20.1046 3 21 3.89543 21 5V7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <path d="M21 17V19C21 20.1046 20.1046 21 19 21H17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <path d="M7 21H5C3.89543 21 3 20.1046 3 19V17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <rect x="7" y="7" width="4" height="4" rx="0.5" fill="currentColor"/>
                <rect x="13" y="7" width="4" height="4" rx="0.5" fill="currentColor"/>
                <rect x="7" y="13" width="4" height="4" rx="0.5" fill="currentColor"/>
              </svg>
            </div>
            <router-link :to="{ path: '/register', query: { type: 'edit' } }" class="edit-profile">
              <span>{{ user_details.name ? user_details.name.charAt(0) : '我' }}</span>
            </router-link>
          </div>
        </div>
        <div class="user-greeting-row">
          <div class="user-greeting">
            <span class="greeting-text">欢迎回来，</span>
            <span class="greeting-name">{{ user_details.name || '学员' }}</span>
          </div>
          <!-- 平台指引入口（小按钮） -->
          <div class="platform-guide-mini" @click="openPlatformGuide">
            <span class="guide-mini-icon">🎬</span>
            <span class="guide-mini-text">平台操作指引</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Banner轮播 -->
    <div class="banner-section">
      <van-swipe class="banner-swipe" :autoplay="4000" indicator-color="#fff">
        <van-swipe-item v-for="(banner, index) in bannerList" :key="index" @click="onBannerClick(banner)">
          <div class="banner-item">
            <img :src="banner.image" :alt="banner.title" />
            <div class="banner-overlay" v-if="banner.title">
              <span class="banner-title">{{ banner.title }}</span>
              <span class="banner-desc" v-if="banner.desc">{{ banner.desc }}</span>
            </div>
          </div>
        </van-swipe-item>
        <!-- 默认Banner（无数据时显示） -->
        <van-swipe-item v-if="bannerList.length === 0">
          <div class="banner-item banner-default">
            <div class="banner-default-bg">
              <div class="bg-circle bg-circle-1"></div>
              <div class="bg-circle bg-circle-2"></div>
              <div class="bg-circle bg-circle-3"></div>
            </div>
            <div class="banner-default-content">
              <svg class="banner-jj-logo" viewBox="0 0 216 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M45.3061 20.8646C43.775 20.8646 42.9213 19.4147 42.9213 16.7914C42.9213 14.1274 43.775 12.7182 45.3061 12.7182C46.8373 12.7182 47.691 14.1491 47.691 16.7914C47.6883 19.4553 46.8346 20.8646 45.3061 20.8646ZM45.3061 11.6261C42.1869 11.6261 40.4579 13.9513 40.4579 16.7914C40.4579 19.6315 42.1869 21.9567 45.3061 21.9567C48.4254 21.9567 50.1544 19.6315 50.1544 16.7914C50.1544 13.9513 48.4254 11.6261 45.3061 11.6261ZM66.9809 11.6261C65.5094 11.6261 64.6964 12.2629 64.2384 13.0759H64.1191V11.8239H61.775V21.7589H64.1191V15.3415C64.1191 13.8727 64.8752 13.0163 66.0866 13.0163C67.26 13.0163 67.775 13.7914 67.775 14.9648V21.7589H70.1191V14.9431C70.1219 12.8971 69.0487 11.6261 66.9809 11.6261ZM75.4444 11.6261C73.279 11.6261 71.6503 12.5394 71.6503 14.4879C71.6503 16.1383 72.7831 17.0326 74.0541 17.3497L76.0406 17.8456C77.0948 18.103 77.5717 18.4824 77.5717 19.3171C77.5717 20.3307 76.8563 20.9079 75.6042 20.9079C74.2519 20.9079 73.5582 20.2521 73.3387 18.6044L71.233 19.2006C71.3522 20.9106 72.943 21.9621 75.3468 21.9621C78.0297 21.9621 79.4796 20.7101 79.4796 18.7236C79.4796 16.8564 78.1869 16.0814 76.8373 15.7426L74.9294 15.2656C73.9755 15.0272 73.5582 14.5908 73.5582 13.954C73.5582 13.1599 74.233 12.683 75.2465 12.683C76.4389 12.683 77.1733 13.3388 77.2736 14.5908L79.2601 13.9946C79.0216 12.599 77.6503 11.6261 75.4444 11.6261ZM85.3007 20.8646C83.7696 20.8646 82.9159 19.4147 82.9159 16.7914C82.9159 14.1274 83.7696 12.7182 85.3007 12.7182C86.8319 12.7182 87.6855 14.1491 87.6855 16.7914C87.6855 19.4553 86.8292 20.8646 85.3007 20.8646ZM85.3007 11.6261C82.1815 11.6261 80.4525 13.9513 80.4525 16.7914C80.4525 19.6315 82.1815 21.9567 85.3007 21.9567C88.42 21.9567 90.149 19.6315 90.149 16.7914C90.149 13.9513 88.42 11.6261 85.3007 11.6261ZM96.7452 11.6261C95.2736 11.6261 94.4606 12.2629 94.0026 13.0759H93.8834V11.8239H91.5392V21.7589H93.8834V15.3415C93.8834 13.8727 94.6395 13.0163 95.8509 13.0163C97.0243 13.0163 97.5392 13.7914 97.5392 14.9648V21.7589H99.8834V14.9431C99.8834 12.8971 98.8102 11.6261 96.7452 11.6261ZM131.574 20.8646C130.043 20.8646 129.19 19.4147 129.19 16.7914C129.19 14.1274 130.043 12.7182 131.574 12.7182C133.106 12.7182 133.959 14.1491 133.959 16.7914C133.959 19.4553 133.103 20.8646 131.574 20.8646ZM131.574 11.6261C128.455 11.6261 126.726 13.9513 126.726 16.7914C126.726 19.6315 128.455 21.9567 131.574 21.9567C134.694 21.9567 136.423 19.6315 136.423 16.7914C136.423 13.9513 134.694 11.6261 131.574 11.6261ZM153.249 11.6261C151.778 11.6261 150.965 12.2629 150.507 13.0759H150.387V11.8239H148.043V21.7589H150.387V15.3415C150.387 13.8727 151.144 13.0163 152.355 13.0163C153.528 13.0163 154.043 13.7914 154.043 14.9648V21.7589H156.387V14.9431C156.39 12.8971 155.317 11.6261 153.249 11.6261ZM161.715 11.6261C159.55 11.6261 157.921 12.5394 157.921 14.4879C157.921 16.1383 159.054 17.0326 160.325 17.3497L162.312 17.8456C163.366 18.103 163.843 18.4824 163.843 19.3171C163.843 20.3307 163.127 20.9079 161.875 20.9079C160.523 20.9079 159.829 20.2521 159.61 18.6044L157.504 19.2006C157.623 20.9106 159.214 21.9621 161.618 21.9621C164.301 21.9621 165.751 20.7101 165.751 18.7236C165.751 16.8564 164.458 16.0814 163.108 15.7426L161.2 15.2656C160.247 15.0272 159.829 14.5908 159.829 13.954C159.829 13.1599 160.504 12.683 161.518 12.683C162.71 12.683 163.444 13.3388 163.545 14.5908L165.531 13.9946C165.29 12.599 163.919 11.6261 161.715 11.6261ZM171.569 20.8646C170.038 20.8646 169.184 19.4147 169.184 16.7914C169.184 14.1274 170.038 12.7182 171.569 12.7182C173.1 12.7182 173.954 14.1491 173.954 16.7914C173.954 19.4553 173.097 20.8646 171.569 20.8646ZM171.569 11.6261C168.45 11.6261 166.721 13.9513 166.721 16.7914C166.721 19.6315 168.45 21.9567 171.569 21.9567C174.688 21.9567 176.417 19.6315 176.417 16.7914C176.417 13.9513 174.688 11.6261 171.569 11.6261ZM183.013 11.6261C181.542 11.6261 180.729 12.2629 180.271 13.0759H180.152V11.8239H177.807V21.7589H180.152V15.3415C180.152 13.8727 180.908 13.0163 182.119 13.0163C183.293 13.0163 183.807 13.7914 183.807 14.9648V21.7589H186.152V14.9431C186.152 12.8971 185.078 11.6261 183.013 11.6261ZM39.0677 7.85101H36.6042V18.122C36.6042 19.7914 35.9674 20.7833 34.4579 20.7833C32.9674 20.7833 32.3116 19.7291 32.3116 17.9215V16.0136L29.8481 16.6288V17.4824C29.8481 20.0841 31.1408 22.0732 34.4579 22.0732C37.775 22.0732 39.0677 20.0868 39.0677 17.4824V7.85101ZM53.8888 7.85101H51.5446V21.7589H53.8888V15.3415C53.8888 13.8727 54.6449 13.0163 55.8563 13.0163C57.0297 13.0163 57.5446 13.7914 57.5446 14.9648V21.7589H59.8888V14.9431C59.8888 12.8971 58.8156 11.6261 56.7506 11.6261C55.279 11.6261 54.466 12.2629 54.008 13.0759H53.8888V7.85101ZM125.336 7.85101H122.873V18.122C122.873 19.7914 122.236 20.7833 120.726 20.7833C119.236 20.7833 118.58 19.7291 118.58 17.9215V16.0136L116.116 16.6288V17.4824C116.116 20.0841 117.409 22.0732 120.726 22.0732C124.043 22.0732 125.336 20.0868 125.336 17.4824V7.85101ZM140.157 7.85101H137.813V21.7589H140.157V15.3415C140.157 13.8727 140.913 13.0163 142.125 13.0163C143.298 13.0163 143.813 13.7914 143.813 14.9648V21.7589H146.157V14.9431C146.157 12.8971 145.084 11.6261 143.019 11.6261C141.547 11.6261 140.734 12.2629 140.276 13.0759H140.157V7.85101ZM107.612 20.6261C105.705 20.6261 104.534 19.0759 104.534 17.4282C104.534 16.3957 104.992 15.4418 105.745 14.9052L110.236 19.8131C109.401 20.309 108.466 20.6261 107.612 20.6261ZM111.984 18.1816L108.089 13.8889C108.786 13.6098 109.461 13.5123 110.016 13.5123C111.626 13.5123 112.618 14.4472 112.618 16.057C112.621 16.7724 112.42 17.5068 111.984 18.1816ZM107.553 13.3144L106.699 12.3605C105.943 11.5258 105.726 11.0082 105.726 10.393C105.726 9.24125 106.461 8.58543 107.612 8.58543C108.786 8.58543 109.48 9.26022 109.48 10.4933C109.48 11.6261 108.924 12.6992 107.553 13.3144ZM107.672 7.53394C104.929 7.53394 103.58 9.0651 103.58 10.9702C103.58 12.0028 104.016 13.038 105.171 14.2873L105.19 14.328C103.244 15.2629 102.35 16.7724 102.35 18.3226C102.35 20.3686 103.919 22.0787 106.344 22.0787C107.734 22.0787 109.363 21.5014 110.835 20.4689L112.027 21.7616H115.146V21.6613L112.604 18.8591C113.677 17.5881 114.293 16.1979 114.293 14.9838C114.293 13.4743 113.279 12.4608 111.691 12.4608C110.856 12.4608 109.921 12.6992 109.306 12.9377L109.266 12.8591C110.775 12.0434 111.412 11.29 111.412 10.2358C111.406 8.72635 110.057 7.53394 107.672 7.53394Z" fill="white"/>
              </svg>
              <span class="banner-default-title">Acuvue iLearn</span>
              <span class="banner-default-slogan">专业视光培训 · 助力职业成长</span>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 快捷导航（简洁风格） -->
    <div class="quick-nav-grid">
      <div class="nav-grid-item" @click="tab_tap(1)">
        <div class="nav-grid-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span>全部课程</span>
      </div>
      <div class="nav-grid-item" @click="tab_tap(2)">
        <div class="nav-grid-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M9 11l3 3L22 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span>在线考试</span>
      </div>
      <div class="nav-grid-item" @click="tab_tap(3)">
        <div class="nav-grid-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
            <polyline points="12,6 12,12 16,14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span>培训记录</span>
      </div>
      <div class="nav-grid-item" @click="tab_tap(4)">
        <div class="nav-grid-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="8" r="6" stroke="currentColor" stroke-width="2"/>
            <path d="M9 14l-1 8 4-2 4 2-1-8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <span>我的证书</span>
      </div>
    </div>

    <!-- 粘性定位锚点 -->
    <div ref="stickyAnchor" class="sticky-anchor" v-if="categoryList.length > 0 || loading"></div>
    <!-- 课程分类 + 课程列表（外卖模式） -->
    <div class="course-section" ref="courseSection" :class="{ 'is-sticky': isCourseSticky }" v-if="categoryList.length > 0 || loading">
      <!-- 标题栏 -->
      <div class="section-header">
        <span class="section-title">推荐课程</span>
        <span class="section-more" @click="tab_tap(1)">更多 ›</span>
      </div>

      <!-- 外卖式布局容器 -->
      <div class="delivery-layout">
        <!-- 左侧分类侧栏 -->
        <div class="sidebar-nav">
          <template v-if="loading">
            <div class="sidebar-item-sk" v-for="i in 7" :key="i"></div>
          </template>
          <template v-else>
            <div
              class="sidebar-item"
              :class="{ active: activeTabIndex === -1 }"
              @click="selectTab(-1)"
            >
              <span class="sidebar-text">全部</span>
            </div>
            <div
              class="sidebar-item"
              :class="{ active: activeTabIndex === catIndex }"
              v-for="(category, catIndex) in flatCategoryList"
              :key="category.Id"
              @click="selectTab(catIndex)"
            >
              <span class="sidebar-text">{{ category.Name }}</span>
            </div>
          </template>
        </div>

        <!-- 右侧课程面板 -->
        <div class="courses-panel" :key="activeTabIndex">
          <!-- 骨架屏 -->
          <div class="course-grid" v-if="loading || coursesLoading">
            <div class="skeleton-v-card" v-for="i in 6" :key="i">
              <div class="skeleton-v-thumb"></div>
              <div class="skeleton-v-body">
                <div class="skeleton-line skeleton-title-line"></div>
                <div class="skeleton-line skeleton-title-line-short"></div>
              </div>
            </div>
          </div>

          <!-- 课程网格 -->
          <div class="course-grid" v-else>
            <div
              class="course-card-v"
              :class="{ 'course-locked': !course.IsUnlocked }"
              v-for="(course, index) in displayCourses"
              :key="course.Id"
              :style="{ animationDelay: index * 0.05 + 's' }"
              @click="handleCourseClick(course)"
            >
              <div class="card-v-thumb">
                <div class="thumb-skeleton"></div>
                <img
                  v-lazy="course.Thumbnail"
                  :alt="course.Subject"
                  class="thumb-img"
                />
                <div class="thumb-lock-v" v-if="!course.IsUnlocked">
                  <span>🔒</span>
                </div>
                <div class="thumb-duration-v" v-if="course.Duration && course.Duration > 0">
                  {{ formatDuration(course.Duration) }}
                </div>
              </div>
              <div class="card-v-body">
                <p class="card-v-title">{{ course.Subject }}</p>
                <div class="card-v-footer">
                  <span v-if="course.IsUnlocked" class="card-v-status unlocked">▶ 学习</span>
                  <span
                    v-else
                    class="card-v-status locked card-v-status-link"
                    @click.stop="handleCourseClick(course)"
                  >点击了解解锁规则</span>
                  <span class="card-v-tag" v-if="getLinkExtension(course.Link)">
                    {{ getLinkExtension(course.Link) }}
                  </span>
                </div>
              </div>
            </div>
            <!-- 空课程提示 -->
            <div class="empty-courses-v" v-if="displayCourses.length === 0">
              <span>暂无课程</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 粘性定位占位符 -->
    <div class="sticky-placeholder" v-if="isCourseSticky" :style="{ height: stickyPlaceholderHeight + 'px' }"></div>

    <!-- 空状态 -->
    <div class="empty-state" v-if="!loading && categoryList.length === 0">
      <div class="empty-icon">📭</div>
      <p class="empty-text">暂无课程，敬请期待</p>
    </div>

    <!-- 密码弹窗 -->
    <van-dialog
      v-model="show_password"
      @confirm="confirm_pass"
      @cancel="show_password = false"
      title="请输入课程密码"
      show-cancel-button
      confirm-button-color="#d51900"
    >
      <div class="password-input-wrapper">
        <van-field
          v-model="PassWord_value"
          type="password"
          input-align="center"
          placeholder="请输入密码"
          class="password-field"
        />
      </div>
    </van-dialog>

    <!-- 解锁提示弹窗 -->
    <unlock-tip-dialog
      :show.sync="show_unlock_tip"
      :unlock-data="unlockTipData"
      :loading="unlockTipLoading"
      @go-course="goToPreCourse"
    />

    <!-- Banner弹框 -->
    <van-dialog
      v-model="showBannerPopup"
      :title="currentPopup ? currentPopup.Title : ''"
      :show-confirm-button="!!currentPopup && !!currentPopup.ButtonText"
      :confirm-button-text="currentPopup ? currentPopup.ButtonText : '确定'"
      @confirm="onPopupConfirm"
    >
      <div class="banner-popup-content" v-if="currentPopup">
        <div v-html="currentPopup.Content"></div>
      </div>
    </van-dialog>

    <!-- 全屏平台指引 -->
    <div class="guide-fullscreen-overlay" v-if="showGuideFullscreen && platformGuideItem">
      <div class="guide-fullscreen-content">
        <div class="guide-header" v-if="!isGuideVideoFullscreen">
          <h2 class="guide-title">🎬 平台操作指引</h2>
        </div>
        <div class="guide-video-wrapper">
          <video
            ref="guideVideo"
            :src="platformGuideItem.VideoUrl"
            controls
            playsinline
            webkit-playsinline
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            @ended="onGuideVideoEnded"
            @play="onGuideVideoPlay"
            @pause="onGuideVideoPause"
            @fullscreenchange="onGuideFullscreenChange"
            @webkitfullscreenchange="onGuideFullscreenChange"
            class="guide-video"
          />
          <!-- 自定义首帧图片覆盖层（点击播放） -->
          <div
            class="guide-poster-overlay"
            v-if="!guideVideoStarted"
            @click="playGuideVideo"
          >
            <img :src="platformGuideItem.CoverUrl" class="guide-poster-img" />
            <div class="guide-play-btn">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 5v14l11-7z"/>
              </svg>
            </div>
          </div>
          <!-- 跳过按钮/倒计时（固定在视频右上角） -->
          <div class="guide-skip-area" v-if="!isGuideVideoFullscreen && !guideVideoEnded && (guideVideoStarted || !isGuideForced)">
            <!-- 手动打开时直接显示跳过，强制观看时需要倒计时3秒 -->
            <button class="guide-skip-btn-inline" @click.stop="onSkipGuide" v-if="!isGuideForced || guideVideoPlayedSeconds >= 3">
              跳过 ›
            </button>
            <span class="guide-skip-countdown-inline" v-else>
              {{ Math.max(0, 3 - guideVideoPlayedSeconds) }}s
            </span>
          </div>
          <!-- 全屏横屏时的跳过按钮 -->
          <button
            class="guide-skip-btn-fullscreen"
            @click="onSkipGuide"
            v-if="isGuideVideoFullscreen && guideVideoPlayedSeconds >= 3 && !guideVideoEnded"
          >
            跳过 ›
          </button>
        </div>
        <div class="guide-description" v-if="platformGuideItem.Description && !isGuideVideoFullscreen">
          {{ platformGuideItem.Description }}
        </div>
        <div class="guide-actions" v-if="!isGuideVideoFullscreen">
          <button class="guide-complete-btn" @click="markGuideViewed" v-if="guideVideoEnded">
            开始使用
          </button>
          <p class="guide-tip" v-else>请观看平台操作指引视频</p>
        </div>
      </div>

      <!-- 跳过确认弹框 -->
      <div class="skip-confirm-overlay" v-if="showSkipConfirm">
        <div class="skip-confirm-box">
          <p class="skip-confirm-text">确定要跳过平台操作指引吗？</p>
          <p class="skip-confirm-hint">您可以稍后在首页点击「平台操作指引」继续观看</p>
          <div class="skip-confirm-actions">
            <button class="skip-cancel-btn" @click="cancelSkipGuide">继续观看</button>
            <button class="skip-confirm-btn" @click="confirmSkipGuide">确认跳过</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Member_QueryMember,
  OAuth_jssdk,
  WeChatCurriculum_MemberScanCodeSignIn,
  WeChatCurriculum_GetCurricularGroup,
  WeChatCurriculum_GetCurriculaByGroupId,
  WeChatCurriculum_GetAllCurriculaWithUnlockStatus,
  WeChatCurriculumUnlock_BatchCheckUnlockStatus,
  WeChatBanner_GetBannerList,
  WeChatPlatformGuide_GetPlatformGuide,
  WeChatMember_MarkGuideViewed
} from '../api/api'
import UnlockTipDialog from '../components/UnlockTipDialog.vue'

export default {
  name: 'home',
  components: {
    UnlockTipDialog
  },
  data () {
    return {
      kc_details: {},
      PassWord_value: '',
      show_password: false,
      show_unlock_tip: false,
      unlockTipData: {},
      unlockTipLoading: false,
      user_details: {},
      categoryList: [],
      allCourses: [], // 所有课程（扁平化）
      activeTabIndex: -1, // -1表示全部
      loading: true, // 页面初始加载
      coursesLoading: false, // 课程列表加载中
      // Banner数据（从后端API获取）
      bannerList: [],
      showBannerPopup: false,
      currentPopup: null,
      // 平台指引
      platformGuideItem: null,
      // 全屏平台指引
      showGuideFullscreen: false,
      isGuideForced: false, // 是否强制观看（首次）
      showSkipConfirm: false,
      guideVideoEnded: false,
      guideVideoPlaying: false,
      guideVideoStarted: false, // 视频是否已开始播放过
      guideVideoPlayedSeconds: 0,
      guideVideoTimer: null,
      isGuideVideoFullscreen: false,
      // 分类滑动提示
      showTabHint: false,
      // 自定义滚动条状态
      canTabScroll: false,
      scrollbarThumbWidth: 30,
      scrollbarThumbLeft: 0,
      scrollbarAnimating: false,
      showScrollbarHintText: false,
      // 粘性定位状态
      isCourseSticky: false,
      stickyPlaceholderHeight: 0
    }
  },
  async mounted () {
    // 所有接口并行加载
    const [memberRes] = await Promise.all([
      Member_QueryMember(),
      this.loadPlatformGuide(),
      this.loadBannerList(),
      this.loadCategories()
    ])

    const { data } = memberRes
    if (data == null || data.status === 412) {
      location.href = location.href.split('#')[0]
      return
    }
    this.user_details = data.response

    // 检查是否需要显示平台指引（首次强制观看）
    if (!this.user_details.HasViewedGuide && this.platformGuideItem) {
      this.isGuideForced = true
      this.showGuideFullscreen = true
    }

    this.$nextTick(() => {
      this.initStickyBehavior()
    })
  },
  watch: {
    // 监听平台指引显示状态，禁止/恢复背景滚动
    showGuideFullscreen (val) {
      if (val) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  beforeDestroy () {
    this.clearGuideVideoTimer()
    this.destroyStickyBehavior()
  },
  computed: {
    // 扁平化分类列表（大分类 + 小分类）
    flatCategoryList () {
      const list = []
      for (const category of this.categoryList) {
        if (category.resultCurriculumGroups && category.resultCurriculumGroups.length > 0) {
          // 有小分类时，展示小分类
          for (const subcat of category.resultCurriculumGroups) {
            list.push({
              ...subcat,
              ParentName: category.Name
            })
          }
        } else {
          // 无小分类时，展示大分类
          list.push(category)
        }
      }
      return list
    },
    // 当前Tab展示的课程
    displayCourses () {
      if (this.activeTabIndex === -1) {
        // 全部
        return this.allCourses
      }
      const selectedCategory = this.flatCategoryList[this.activeTabIndex]
      if (!selectedCategory) return []
      return this.allCourses.filter(c => c.GroupId === selectedCategory.Id)
    }
  },
  methods: {
    selectTab (index) {
      this.activeTabIndex = index
    },
    getLinkExtension (link) {
      if (link && typeof link === 'string') {
        const parts = link.split('.')
        if (parts.length > 1) {
          const ext = parts[parts.length - 1].toUpperCase()
          return ext === 'MP4' ? '视频' : ext
        }
      }
      return ''
    },
    formatDuration (seconds) {
      if (!seconds || seconds <= 0) return ''
      const h = Math.floor(seconds / 3600)
      const m = Math.floor((seconds % 3600) / 60)
      const s = seconds % 60
      if (h > 0) {
        return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
      }
      return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
    },
    // 加载分类和课程（使用聚合接口，一次请求获取全部数据）
    async loadCategories () {
      this.loading = true
      try {
        const openId = localStorage.getItem('openid') || ''
        const { data } = await WeChatCurriculum_GetAllCurriculaWithUnlockStatus(openId)

        if (data.success && data.response) {
          // 转换数据格式以兼容现有UI
          const categories = data.response.map(group => ({
            Id: group.Id,
            Name: group.Name,
            Remark: group.Remark,
            resultCurriculumGroups: group.Children.map(child => ({
              Id: child.Id,
              Name: child.Name,
              Remark: child.Remark
            }))
          }))
          this.categoryList = categories

          // 扁平化所有课程
          const allCourses = []
          for (const group of data.response) {
            if (group.Children && group.Children.length > 0) {
              for (const child of group.Children) {
                if (child.Courses) {
                  allCourses.push(...child.Courses.map(c => ({
                    ...c,
                    GroupId: child.Id,
                    CategoryName: child.Name,
                    ParentCategoryName: group.Name,
                    Thumbnail: c.Thumbnail
                  })))
                }
              }
            } else if (group.Courses) {
              allCourses.push(...group.Courses.map(c => ({
                ...c,
                GroupId: group.Id,
                CategoryName: group.Name,
                ParentCategoryName: ''
              })))
            }
          }
          this.allCourses = allCourses
        }
        this.loading = false
        this.coursesLoading = false
      } catch (e) {
        console.error('加载数据失败', e)
        // 降级到旧的加载方式
        await this.loadCategoriesLegacy()
      }
    },
    // 旧的加载方式（作为降级方案）
    async loadCategoriesLegacy () {
      this.loading = true
      try {
        const { data: groupData } = await WeChatCurriculum_GetCurricularGroup()
        const categories = groupData.response || []
        this.categoryList = categories
        this.loading = false
        this.loadAllCourses(categories)
      } catch (e) {
        console.error('加载分类失败', e)
        this.loading = false
      }
    },
    // 加载所有课程（扁平化存储）
    async loadAllCourses (categories) {
      this.coursesLoading = true
      const loadPromises = []
      const categoryInfoMap = {} // 存储分类信息

      for (const category of categories) {
        if (category.resultCurriculumGroups && category.resultCurriculumGroups.length > 0) {
          for (const subcat of category.resultCurriculumGroups) {
            categoryInfoMap[subcat.Id] = {
              categoryName: subcat.Name,
              parentName: category.Name
            }
            loadPromises.push(this.loadCoursesForGroup(subcat.Id, categoryInfoMap[subcat.Id]))
          }
        } else {
          categoryInfoMap[category.Id] = {
            categoryName: category.Name,
            parentName: ''
          }
          loadPromises.push(this.loadCoursesForGroup(category.Id, categoryInfoMap[category.Id]))
        }
      }

      const results = await Promise.all(loadPromises)
      this.allCourses = results.flat()
      this.coursesLoading = false
    },
    // 加载单个分类的课程
    async loadCoursesForGroup (groupId, categoryInfo) {
      try {
        const { data: courseData } = await WeChatCurriculum_GetCurriculaByGroupId({ Id: groupId })
        let courses = courseData.response || []

        const openId = localStorage.getItem('openid')
        if (courses.length > 0 && openId) {
          try {
            const courseIds = courses.map(c => c.Id)
            const { data: unlockData } = await WeChatCurriculumUnlock_BatchCheckUnlockStatus(courseIds, openId)
            if (unlockData && unlockData.success) {
              const unlockMap = {}
              unlockData.response.forEach(status => {
                unlockMap[status.CurriculumId] = status
              })
              courses = courses.map(c => this.mergeUnlockStatus(c, unlockMap))
            }
          } catch (e) {
            courses = courses.map(c => ({ ...c, IsUnlocked: true }))
          }
        } else {
          courses = courses.map(c => ({ ...c, IsUnlocked: true }))
        }

        // 添加分类信息到每个课程
        return courses.map(c => ({
          ...c,
          GroupId: groupId,
          CategoryName: categoryInfo.categoryName,
          ParentCategoryName: categoryInfo.parentName
        }))
      } catch (e) {
        console.log('加载课程失败', e)
        return []
      }
    },
    mergeUnlockStatus (course, unlockMap) {
      const status = unlockMap[course.Id]
      return {
        ...course,
        IsUnlocked: status ? status.IsUnlocked : true,
        UnlockProgress: status ? status.UnlockProgress : '',
        UnlockRuleDesc: status ? status.UnlockRuleDesc : '',
        UnfinishedPreCurriculums: status ? status.UnfinishedPreCurriculums : [],
        PreCurriculumList: status ? status.PreCurriculumList : [],
        UnlockRules: status ? status.UnlockRules : []
      }
    },
    async handleCourseClick (course) {
      if (this.unlockTipLoading) return
      if (!course.IsUnlocked) {
        // 先显示弹框骨架屏
        this.unlockTipData = {}
        this.unlockTipLoading = true
        this.show_unlock_tip = true
        try {
          // 调用原接口获取完整解锁信息
          const openId = localStorage.getItem('openid') || ''
          const { data } = await WeChatCurriculumUnlock_BatchCheckUnlockStatus(
            [course.Id],
            openId
          )
          if (data.success && data.response && data.response.length > 0) {
            const status = data.response[0]
            this.unlockTipData = {
              UnlockRuleDesc: status.UnlockRuleDesc || '需完成前置课程',
              UnlockProgress: status.UnlockProgress || '',
              UnfinishedPreCurriculums: status.UnfinishedPreCurriculums || [],
              PreCurriculumList: status.PreCurriculumList || [],
              UnlockRules: status.UnlockRules || []
            }
          } else {
            this.show_unlock_tip = false
            this.$toast('无法获取解锁信息')
          }
        } catch (e) {
          console.error('获取解锁信息失败', e)
          this.show_unlock_tip = false
          this.$toast('获取解锁信息失败')
        } finally {
          this.unlockTipLoading = false
        }
        return
      }

      if (course.PassWord) {
        this.PassWord_value = ''
        this.kc_details = course
        this.show_password = true
      } else {
        this.$router.push({
          path: '/classStudy',
          query: { ids: course.Id }
        })
      }
    },
    scan () {
      OAuth_jssdk({
        url: location.href.split('#')[0]
      }).then(res => {
        const that = this
        // eslint-disable-next-line no-undef
        wx.config({
          debug: false,
          appId: res.data.response.appId,
          timestamp: res.data.response.timestamp,
          nonceStr: res.data.response.nonceStr,
          signature: res.data.response.signature,
          jsApiList: ['checkJsApi', 'scanQRCode']
        })
        // eslint-disable-next-line no-undef
        wx.ready(function () {
          // eslint-disable-next-line no-undef
          wx.checkJsApi({
            jsApiList: ['scanQRCode'],
            success: function (res) {
              if (res.checkResult.scanQRCode === true) {
                // eslint-disable-next-line no-undef
                wx.scanQRCode({
                  desc: 'scanQRCode desc',
                  needResult: 1,
                  scanType: ['qrCode', 'barCode'],
                  success: function (res) {
                    that.WeChatCurriculum_MemberScanCodeSignIn_fn(res.resultStr)
                  }
                })
              } else {
                alert('抱歉，当前客户端版本不支持扫一扫')
              }
            }
          })
        })
      })
    },
    async WeChatCurriculum_MemberScanCodeSignIn_fn (code) {
      const { data } = await WeChatCurriculum_MemberScanCodeSignIn({ code })
      this.$dialog({
        message: data.msg,
        confirmButtonColor: '#00b7ee'
      })
    },
    confirm_pass () {
      if (this.kc_details.PassWord === this.PassWord_value) {
        this.$router.push({
          path: '/classStudy',
          query: { ids: this.kc_details.Id }
        })
      } else {
        this.$toast('密码错误')
      }
    },
    tab_tap (type) {
      const routes = {
        1: '/class_list',
        2: '/examination_list',
        3: '/training_list',
        4: '/certificate_list'
      }
      this.$router.push({ path: routes[type] })
    },
    onBannerClick (banner) {
      // 根据链接类型处理点击
      switch (banner.LinkType) {
        case 1: // 内部页面
          if (banner.LinkUrl) {
            this.$router.push(banner.LinkUrl)
          }
          break
        case 2: // 外部链接
          if (banner.LinkUrl) {
            window.location.href = banner.LinkUrl
          }
          break
        case 3: // 弹框
          if (banner.Popup) {
            this.currentPopup = banner.Popup
            this.showBannerPopup = true
          }
          break
        default:
          // 无链接，不处理
          break
      }
    },
    // 加载平台指引
    async loadPlatformGuide () {
      if (this.platformGuideItem) return // 已加载则跳过
      try {
        const { data } = await WeChatPlatformGuide_GetPlatformGuide()
        if (data.success && data.response) {
          this.platformGuideItem = data.response
        }
      } catch (e) {
        console.error('加载平台指引失败', e)
      }
    },
    // 加载Banner列表
    async loadBannerList () {
      try {
        const { data } = await WeChatBanner_GetBannerList({ Platform: 1 })
        if (data.success && data.response) {
          this.bannerList = data.response.map(item => ({
            id: item.Id,
            image: item.ImageUrl,
            title: item.Title,
            LinkType: item.LinkType,
            LinkUrl: item.LinkUrl,
            Popup: item.Popup
          }))
        }
      } catch (e) {
        console.error('加载Banner失败', e)
      }
    },
    goToPreCourse (course) {
      this.show_unlock_tip = false
      this.$nextTick(() => {
        this.$router.push({
          path: '/classStudy',
          query: { ids: course.Id }
        })
      })
    },
    // Banner弹框确认按钮
    onPopupConfirm () {
      if (this.currentPopup && this.currentPopup.ButtonLink) {
        if (this.currentPopup.ButtonLink.startsWith('http')) {
          window.location.href = this.currentPopup.ButtonLink
        } else {
          this.$router.push(this.currentPopup.ButtonLink)
        }
      }
      this.showBannerPopup = false
      this.currentPopup = null
    },
    // 平台指引（手动点击入口）
    openPlatformGuide () {
      if (!this.platformGuideItem) {
        this.$toast('暂无平台操作指引')
        return
      }
      // 重置状态
      this.guideVideoStarted = false
      this.guideVideoEnded = false
      this.guideVideoPlaying = false
      this.guideVideoPlayedSeconds = 0
      this.isGuideForced = false
      this.showGuideFullscreen = true
    },
    // 全屏指引视频播放完成
    onGuideVideoEnded () {
      this.guideVideoEnded = true
      this.guideVideoPlaying = false
      this.clearGuideVideoTimer()
      this.markGuideViewed()
    },
    // 点击首帧图片播放视频
    playGuideVideo () {
      const video = this.$refs.guideVideo
      if (video) {
        video.play()
      }
    },
    // 视频开始播放
    onGuideVideoPlay () {
      this.guideVideoPlaying = true
      this.guideVideoStarted = true
      this.startGuideVideoTimer()
    },
    // 视频暂停
    onGuideVideoPause () {
      this.guideVideoPlaying = false
      this.clearGuideVideoTimer()
    },
    // 开始计时器
    startGuideVideoTimer () {
      this.clearGuideVideoTimer()
      this.guideVideoTimer = setInterval(() => {
        if (this.guideVideoPlayedSeconds < 3) {
          this.guideVideoPlayedSeconds++
        } else {
          this.clearGuideVideoTimer()
        }
      }, 1000)
    },
    // 清除计时器
    clearGuideVideoTimer () {
      if (this.guideVideoTimer) {
        clearInterval(this.guideVideoTimer)
        this.guideVideoTimer = null
      }
    },
    // 全屏状态变化
    onGuideFullscreenChange () {
      const video = this.$refs.guideVideo
      this.isGuideVideoFullscreen = !!(document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        (video && video.webkitDisplayingFullscreen))
    },
    // 点击跳过按钮
    onSkipGuide () {
      // 如果在全屏模式，先退出全屏
      if (this.isGuideVideoFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        }
      }
      this.showSkipConfirm = true
    },
    // 确认跳过
    async confirmSkipGuide () {
      this.showSkipConfirm = false
      this.clearGuideVideoTimer()
      await this.markGuideViewed()
    },
    // 取消跳过
    cancelSkipGuide () {
      this.showSkipConfirm = false
    },
    // 标记已观看平台指引
    async markGuideViewed () {
      this.clearGuideVideoTimer()
      try {
        const openId = localStorage.getItem('openid')
        if (openId) {
          await WeChatMember_MarkGuideViewed(openId)
        }
      } catch (e) {
        console.error('标记平台指引失败', e)
      }
      this.showGuideFullscreen = false
      this.user_details.HasViewedGuide = true
    },
    // 分类滑动提示 - 适老化优化
    initTabScrollHint () {
      const el = this.$refs.tabsScroll
      if (!el) return

      const canScroll = el.scrollWidth > el.clientWidth
      this.canTabScroll = canScroll

      if (canScroll) {
        // 计算滚动条滑块宽度（视口宽度占总宽度的比例）
        this.scrollbarThumbWidth = Math.max(20, (el.clientWidth / el.scrollWidth) * 100)
        this.scrollbarThumbLeft = 0

        // 显示右侧箭头提示
        this.showTabHint = true

        // 显示滚动条提示文字
        this.showScrollbarHintText = true

        // 延迟执行示意动画
        setTimeout(() => {
          this.playScrollHintAnimation(el)
        }, 500)

        // 5秒后隐藏提示文字
        setTimeout(() => {
          this.showScrollbarHintText = false
        }, 5000)

        // 4秒后隐藏箭头提示
        setTimeout(() => {
          this.showTabHint = false
        }, 4000)
      }
    },
    // 播放滑动示意动画
    playScrollHintAnimation (el) {
      if (!el) return

      // 滚动条滑块示意动画
      this.scrollbarAnimating = true

      // 分类列表自动滑动示意
      const scrollDistance = Math.min(80, el.scrollWidth - el.clientWidth)

      // 平滑滚动到右边
      el.scrollTo({
        left: scrollDistance,
        behavior: 'smooth'
      })

      // 然后滚动回来
      setTimeout(() => {
        el.scrollTo({
          left: 0,
          behavior: 'smooth'
        })

        // 动画结束后停止滚动条动画
        setTimeout(() => {
          this.scrollbarAnimating = false
        }, 400)
      }, 600)
    },
    // 分类滚动事件处理
    onTabScroll () {
      const el = this.$refs.tabsScroll
      if (!el) return

      // 隐藏箭头提示
      if (this.showTabHint) {
        this.showTabHint = false
      }

      // 隐藏提示文字
      if (this.showScrollbarHintText) {
        this.showScrollbarHintText = false
      }

      // 更新滚动条位置
      if (this.canTabScroll) {
        const maxScrollLeft = el.scrollWidth - el.clientWidth
        if (maxScrollLeft > 0) {
          const scrollPercent = el.scrollLeft / maxScrollLeft
          const maxThumbLeft = 100 - this.scrollbarThumbWidth
          this.scrollbarThumbLeft = scrollPercent * maxThumbLeft
        }
      }
    },
    // 初始化粘性定位行为（饿了么/美团风格）
    initStickyBehavior () {
      this._stickyScrollHandler = () => {
        this.handleStickyScroll()
      }
      window.addEventListener('scroll', this._stickyScrollHandler, { passive: true })
      // 初始检查（处理页面刷新时已滚动的情况）
      this.handleStickyScroll()
    },
    // 处理滚动时的粘性定位逻辑
    handleStickyScroll () {
      const anchor = this.$refs.stickyAnchor
      const section = this.$refs.courseSection
      if (!anchor || !section) return

      const anchorRect = anchor.getBoundingClientRect()
      const shouldStick = anchorRect.top <= 0

      if (shouldStick && !this.isCourseSticky) {
        // 记录固定前的原始高度用于占位（包含margin）
        const sectionStyles = window.getComputedStyle(section)
        const sectionMarginTop = parseInt(sectionStyles.marginTop) || 0
        this.stickyPlaceholderHeight = section.offsetHeight + sectionMarginTop
        // 动态计算标题栏高度，设置CSS变量
        const header = section.querySelector('.section-header')
        if (header) {
          section.style.setProperty('--sticky-header-h', (header.offsetHeight + 4) + 'px')
        }
        this.isCourseSticky = true
      } else if (!shouldStick && this.isCourseSticky) {
        this.isCourseSticky = false
      }
    },
    // 销毁粘性定位行为
    destroyStickyBehavior () {
      if (this._stickyScrollHandler) {
        window.removeEventListener('scroll', this._stickyScrollHandler)
        this._stickyScrollHandler = null
      }
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: #f8f9fa;
  padding-bottom: 40px;
  /* 移除 transform 以修复 iOS 上 fixed 弹窗定位问题 */
  /* -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-perspective: 1000;
  perspective: 1000; */
  /* 保持顺滑滚动 */
  -webkit-overflow-scrolling: touch;
}

/* ========== 顶部区域 - 强生主题调整 ========== */
.home-header {
  background: #fff;
  padding: 12px 16px 16px;
  position: relative;
  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;
  z-index: 20;
}

/* 移除旧的背景动画和装饰圆 */
.header-decoration, .deco-circle, .deco-circle-1, .deco-circle-2 {
  display: none;
}

.header-content {
  position: relative;
  z-index: 1;
}

.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.logo-area {
  display: flex;
  align-items: center;
}

.jj-logo {
  width: 200px;
  height: auto;
  margin-left: -29px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.scan-btn {
  width: 36px;
  height: 36px;
  background: #f5f7fa; /* 浅灰色背景 */
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333; /* 图标颜色 */
}

.scan-btn:active {
  background: #e8ebf0;
}

.scan-icon {
  width: 20px;
  height: 20px;
}

.edit-profile {
  width: 36px;
  height: 36px;
  background: #d51900; /* 红色背景 */
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #fff; /* 白色文字 */
  text-decoration: none;
  box-shadow: 0 4px 10px rgba(213, 25, 0, 0.2);
}

/* 问候语行（左右布局） */
.user-greeting-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f5f5f5;
}

.user-greeting {
  display: flex;
  align-items: center; /* 放在一行 */
  gap: 4px;
}

.greeting-text {
  font-size: 14px;
  color: #666;
}

.greeting-name {
  font-size: 16px;
  font-weight: 700;
  color: #1a2a3a;
}

/* 平台指引迷你按钮 */
.platform-guide-mini {
  display: flex;
  align-items: center;
  gap: 4px;
  /* background: #fff5f5; 去掉背景色，更简洁 */
  /* border: 1px solid rgba(213, 25, 0, 0.15); 去掉边框 */
  padding: 4px 0; /* 减小内边距 */
  cursor: pointer;
}

.platform-guide-mini:active {
  opacity: 0.6;
}

.guide-mini-icon {
  font-size: 14px;
}

.guide-mini-text {
  font-size: 13px;
  color: #555; /* 颜色改深一点 */
  font-weight: 500;
}

/* ========== Banner轮播 ========== */
.banner-section {
  padding: 0 16px;
  margin-top: 16px;
  position: relative;
  z-index: 5;
}

.banner-swipe {
  width: 100%;
  /* 强制宽高比 2.3:1 */
  aspect-ratio: 2.3 / 1;
  height: auto !important; /* 覆盖旧的height */
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
}

.banner-swipe .van-swipe-item {
  height: 100%;
}

.banner-item {
  position: relative;
  width: 100%;
  height: 100%;
  background: #eee;
}

.banner-item img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 确保填充 */
}

.banner-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, transparent 100%);
}

.banner-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
}

.banner-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 4px;
  display: block;
}

.banner-default {
  background: linear-gradient(135deg, #d51900 0%, #b01500 50%, #8a1000 100%);
  position: relative;
  overflow: hidden;
}

.banner-default-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
}

.bg-circle-1 {
  width: 150px;
  height: 150px;
  top: -60px;
  right: -40px;
}

.bg-circle-2 {
  width: 100px;
  height: 100px;
  bottom: -30px;
  left: -30px;
}

.bg-circle-3 {
  width: 60px;
  height: 60px;
  top: 30%;
  right: 20%;
}

.banner-default-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 8px;
}

.banner-jj-logo {
  width: 140px;
  height: auto;
}

.banner-default-title {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 2px;
}

.banner-default-slogan {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 1px;
}

/* ========== 快捷导航（简洁风格） ========== */
.quick-nav-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 4px;
  background: #fff;
  margin: 16px 16px 0;
  padding: 10px 8px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  /* 渐显动画 */
  animation: fadeIn 0.8s ease-out forwards;
  opacity: 0;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.nav-grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  padding: 5px 0;
  cursor: pointer;
  transition: all 0.2s ease;
}

.nav-grid-item:active {
  transform: scale(0.95);
}

.nav-grid-item:nth-child(1) .nav-grid-icon { color: #d51900; }
.nav-grid-item:nth-child(2) .nav-grid-icon { color: #ff6b4a; }
.nav-grid-item:nth-child(3) .nav-grid-icon { color: #52c41a; }
.nav-grid-item:nth-child(4) .nav-grid-icon { color: #faad14; }

.nav-grid-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.nav-grid-icon svg {
  width: 28px;
  height: 28px;
}

.nav-grid-item span:last-child {
  font-size: 13px;
  color: #3a4a5a;
  font-weight: 600;
}

/* ========== 课程分类区域 ========== */
.course-section {
  padding: 0 16px;
  margin-top: 14px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 10px 0;
  margin-bottom: 0;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a2a3a;
}

.section-more {
  font-size: 13px;
  color: #d51900;
  font-weight: 500;
}

/* ========== 粘性定位（饿了么/美团风格） ========== */
.sticky-anchor {
  height: 0;
  overflow: hidden;
  pointer-events: none;
}

.sticky-placeholder {
  pointer-events: none;
}

.course-section.is-sticky {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: 0 16px;
  background: #f8f9fa;
  margin-top: 0;
}

.course-section.is-sticky .section-header {
  padding-top: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  margin-bottom: 0;
}

.course-section.is-sticky .delivery-layout {
  height: calc(100vh - var(--sticky-header-h, 50px));
  min-height: unset;
  border-radius: 0;
  margin-top: 4px;
}

.course-section.is-sticky .sidebar-nav,
.course-section.is-sticky .courses-panel {
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

/* ========== 外卖模式：分类侧栏 + 课程网格 ========== */

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* 外卖布局容器 */
.delivery-layout {
  display: flex;
  height: 68vh;
  min-height: 420px;
  background: #f5f6f8;
  border-radius: 14px;
  overflow: hidden;
  margin-top: 8px;
}

/* 左侧分类侧栏 */
.sidebar-nav {
  width: 80px;
  flex-shrink: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f5f6f8;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.sidebar-nav::-webkit-scrollbar {
  display: none;
}

.sidebar-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 6px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
  position: relative;
  text-align: center;
  min-height: 52px;
}

.sidebar-item:active {
  background: rgba(213, 25, 0, 0.06);
}

.sidebar-text {
  font-size: 12px;
  font-weight: 500;
  color: #666;
  line-height: 1.4;
  word-break: break-all;
}

.sidebar-item.active {
  background: #fff;
}

.sidebar-item.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 22px;
  background: #d51900;
  border-radius: 0 3px 3px 0;
}

.sidebar-item.active .sidebar-text {
  color: #d51900;
  font-weight: 700;
}

/* 侧栏骨架屏 */
.sidebar-item-sk {
  margin: 10px 10px;
  height: 32px;
  border-radius: 6px;
  background: linear-gradient(90deg, #ebebeb 25%, #e0e0e0 50%, #ebebeb 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

/* 右侧课程面板 */
.courses-panel {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: #f7f8fa;
  padding: 10px 8px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.courses-panel::-webkit-scrollbar {
  display: none;
}

/* 课程列表（单列） */
.course-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* 竖向课程卡片（图上文下） */
.course-card-v {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  animation: cardFadeIn 0.4s ease-out backwards;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.course-card-v:active {
  transform: scale(0.98);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 卡片封面图（16:9 比例，全出血） */
.card-v-thumb {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #eef0f3;
}

.card-v-thumb .thumb-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #eef0f3;
}

.card-v-thumb .thumb-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #eef0f3;
  z-index: 1;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
}

.card-v-thumb .thumb-img[lazy="loading"] {
  opacity: 0;
}

.card-v-thumb .thumb-img[lazy="loaded"] {
  opacity: 1;
  transition: opacity 0.3s ease;
}

.thumb-lock-v {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  z-index: 5;
}

.thumb-duration-v {
  position: absolute;
  bottom: 6px;
  right: 6px;
  padding: 2px 6px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  font-size: 10px;
  color: #fff;
  font-weight: 500;
  z-index: 5;
  letter-spacing: 0.3px;
}

/* 锁定时时长移到左下角 */
.course-card-v.course-locked .thumb-duration-v {
  right: auto;
  left: 6px;
}

.course-card-v.course-locked .card-v-thumb .thumb-img {
  filter: grayscale(20%) brightness(0.9);
}

.course-card-v.course-locked .card-v-body {
  opacity: 0.6;
}

/* 卡片内容区（图片下方） */
.card-v-body {
  padding: 10px 10px 8px;
}

.card-v-title {
  font-size: 13px;
  font-weight: 600;
  color: #1a2a3a;
  margin: 0 0 6px;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}

.card-v-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-v-status {
  font-size: 11px;
  font-weight: 600;
}

.card-v-status.unlocked {
  color: #d51900;
}

.card-v-status.locked {
  color: #bbb;
}

.card-v-status-link {
  color: #d51900;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.card-v-tag {
  font-size: 10px;
  color: #d51900;
  background: rgba(213, 25, 0, 0.06);
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
}

/* 课程卡片骨架屏（竖向布局） */
.skeleton-v-card {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.skeleton-v-thumb {
  width: 100%;
  aspect-ratio: 16 / 9;
  background: linear-gradient(90deg, #eef0f3 25%, #e6e8eb 50%, #eef0f3 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

.skeleton-v-body {
  padding: 10px 10px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-line {
  background: linear-gradient(90deg, #eef0f3 25%, #e6e8eb 50%, #eef0f3 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
  border-radius: 4px;
}

.skeleton-title-line {
  height: 14px;
  width: 85%;
}

.skeleton-title-line-short {
  height: 14px;
  width: 50%;
}

/* 空课程提示（右侧面板内） */
.empty-courses-v {
  grid-column: 1 / -1;
  text-align: center;
  padding: 40px 0;
  color: #8a9aaa;
  font-size: 13px;
}

/* ========== 空课程提示 ========== */
.empty-courses {
  text-align: center;
  padding: 40px 0;
  color: #8a9aaa;
  font-size: 14px;
}

/* ========== 空状态 ========== */
.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-icon {
  font-size: 56px;
  margin-bottom: 12px;
}

.empty-text {
  font-size: 14px;
  color: #8a9aaa;
  margin: 0;
}

/* ========== 弹窗样式 ========== */
.password-input-wrapper {
  padding: 20px;
}


.password-field {
  background: #f5f9fc !important;
  border-radius: 12px !important;
}

/* Banner弹框样式 */
.banner-popup-content {
  padding: 16px 20px;
  max-height: 60vh;
  overflow-y: auto;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.banner-popup-content img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 10px 0;
}

/* ========== 全屏平台指引 ========== */
.guide-fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  padding-top: calc(20px + env(safe-area-inset-top));
  padding-bottom: calc(20px + env(safe-area-inset-bottom));
}

.guide-fullscreen-content {
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.guide-header {
  text-align: center;
}

.guide-header {
  text-align: center;
  position: relative;
  width: 100%;
  height: 40px;
}

.guide-title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin: 0;
}


.guide-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

.guide-video-wrapper {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
  position: relative;
  /* 保持 16:9 宽高比 */
  aspect-ratio: 16 / 9;
}

.guide-video {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  background: #000;
}

/* 自定义首帧图片覆盖层 */
.guide-poster-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.guide-poster-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #000;
}

.guide-play-btn {
  position: absolute;
  width: 64px;
  height: 64px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: transform 0.2s, background 0.2s;
}

.guide-play-btn svg {
  width: 32px;
  height: 32px;
  margin-left: 4px;
}

.guide-poster-overlay:active .guide-play-btn {
  transform: scale(0.95);
  background: rgba(0, 0, 0, 0.8);
}

.guide-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  text-align: center;
  padding: 0 10px;
}

.guide-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  min-height: 60px;
}

.guide-tip {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

/* 视频右上角跳过区域 */
.guide-skip-area {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 5;
}

.guide-skip-btn-inline {
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.guide-skip-btn-inline:active {
  background: rgba(0, 0, 0, 0.8);
}

.guide-skip-countdown-inline {
  display: inline-block;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(0, 0, 0, 0.5);
  border-radius: 16px;
}

/* 全屏横屏时的跳过按钮（类似爱奇艺） */
.guide-skip-btn-fullscreen {
  position: absolute;
  top: 16px;
  right: 16px;
  padding: 8px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 20px;
  cursor: pointer;
  z-index: 10;
  transition: all 0.2s ease;
}

.guide-skip-btn-fullscreen:active {
  background: rgba(0, 0, 0, 0.8);
}

.guide-complete-btn {
  padding: 12px 40px;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #d51900 0%, #ff3b2f 100%);
  border: none;
  border-radius: 25px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(213, 25, 0, 0.4);
  transition: all 0.2s ease;
}

.guide-complete-btn:active {
  transform: scale(0.98);
}

/* 跳过确认弹框 */
.skip-confirm-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.skip-confirm-box {
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px;
  max-width: 320px;
  text-align: center;
}

.skip-confirm-text {
  font-size: 18px;
  font-weight: 600;
  color: #1a2a3a;
  margin: 0 0 8px;
}

.skip-confirm-hint {
  font-size: 14px;
  color: #888;
  margin: 0 0 24px;
  line-height: 1.5;
}

.skip-confirm-actions {
  display: flex;
  gap: 12px;
}

.skip-cancel-btn {
  flex: 1;
  padding: 12px 0;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #d51900 0%, #ff3b2f 100%);
  border: none;
  border-radius: 25px;
  cursor: pointer;
}

.skip-confirm-btn {
  flex: 1;
  padding: 12px 0;
  font-size: 15px;
  font-weight: 600;
  color: #666;
  background: #f5f5f5;
  border: none;
  border-radius: 25px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue